import { RouteItem } from '@eastcoal/router/types/route'

import { MEMBER_GROUP_LIST_PAGE_PATH } from './constant/path'
import {
  MEMBER_GROUP_LIST_PAGE_UUID,
  MEMBER_GROUP_MANAGER_ACTION_UUID
} from './constant/uuid'

export const memberGroupRoute: RouteItem = {
  title: '客户分组',
  hideChildrenInMenu: true,
  children: [
    {
      title: '客户分组列表',
      path: MEMBER_GROUP_LIST_PAGE_PATH,
      uuid: MEMBER_GROUP_LIST_PAGE_UUID,
      Component: () => import('./index')
    },
    {
      title: '管理客户分组',
      uuid: MEMBER_GROUP_MANAGER_ACTION_UUID
    }
  ]
}
